<template>
	<section class="content">
		<div class="card">
			<div class="overlay" v-if="loading"><h1 style="font-size:40px;">Sedang diproses <i class="fas fa-sync-alt fa-spin"></i></h1></div>
			<div class="card-body">
				<div v-if="infoDownload" class="form-control bos-alert-primary lh-1 d-flex align-items-center h-100" style="margin-bottom: 15px;">
					<div class="row">
						<div class="col-auto d-flex align-items-center">
							<i class="fi fi-rr-info d-flex align-items-center"></i>
						</div>
						<div class="col d-flex align-items-center">
							<div class="text-md">
								Semua file yang Anda unduh akan tersimpan dan dapat dilihat di <a href="/data-center" class="text-info" style="text-decoration: underline;">menu data center</a>
							</div>
						</div>
					</div>
				</div>
				<div class="row mb-3" style="row-gap: .5rem;">
					<div class="col-12 col-sm-6 col-md-3">
						<div class="info-box border border-primary bg-bottom-primary">
							<!-- <span class="info-box-icon bg-info elevation-2"><i class="fas fa-bookmark"></i></span> -->
							<div class="info-box-content text-center w-100">
								<h6 class="info-box-text font-weight-normal">Nama Rekanan</h6>
								<h6 class="info-box-content mb-0 font-weight-bold" v-bind:class="{ 'skeleton-item': loading && !rekan.nama_rekan }">{{ rekan.nama_rekan ? rekan.nama_rekan : '\xa0' }}</h6>
							</div>
						</div>
					</div>
					<div class="col-12 col-sm-6 col-md-3">
						<div class="info-box border border-primary bg-bottom-primary">
							<!-- <span class="info-box-icon bg-info elevation-2"><i class="fas fa-bookmark"></i></span> -->
							<div class="info-box-content text-center w-100">
								<h6 class="info-box-text font-weight-normal">Nama PIC</h6>
								<h6 class="info-box-content mb-0 font-weight-bold" v-bind:class="{ 'skeleton-item': loading && !rekan.nama_pic }">{{ rekan.nama_pic ? rekan.nama_pic : '\xa0' }}</h6>
							</div>
						</div>
					</div>
					<div class="col-12 col-sm-6 col-md-3">
						<div class="info-box border border-primary bg-bottom-primary">
							<!-- <span class="info-box-icon bg-info elevation-2"><i class="fas fa-bookmark"></i></span> -->
							<div class="info-box-content text-center w-100">
								<h6 class="info-box-text font-weight-normal">Contact Person PIC</h6>
								<h6 class="info-box-content mb-0 font-weight-bold" v-bind:class="{ 'skeleton-item': loading && !rekan.telp_pic }">{{ rekan.telp_pic ? rekan.telp_pic : '\xa0' }}</h6>
							</div>
						</div>
					</div>
					<div class="col-12 col-sm-6 col-md-3">
						<div class="info-box border border-primary bg-bottom-primary">
							<!-- <span class="info-box-icon bg-info elevation-2"><i class="fas fa-bookmark"></i></span> -->
							<div class="info-box-content text-center w-100">
								<h6 class="info-box-text font-weight-normal">Sisa Tagihan</h6>
								<h6 class="info-box-content mb-0 font-weight-bold" v-bind:class="{ 'skeleton-item': loading && !rekan.sisa_tagihan, 'text-danger' : rekan.sisa_tagihan < 0 }">{{ rekan.sisa_tagihan ? formatRupiah(rekan.sisa_tagihan) : '\xa0' }}</h6>
							</div>
						</div>
					</div>
				</div>
				<div class="row mb-3" style="row-gap: .5rem;">
					<div class="col-12 col-sm-auto">
						<div class="input-group">
							<input type="text" ref="daterange" class="form-control border-right-0" style="border-right: 0" />
							<div class="input-group-append">
								<div class="input-group-text rounded-right d-flex align-items-center border-left-0 pl-1 bg-white">
									<i class="fi fi-rr-calendar d-flex"></i>
								</div>
							</div>
						</div>
					</div>
					<div class="col col-sm-auto text-right ml-auto">
						<div class="btn-group" ref="toolbar">
							<button type="button" data-action="read" class="btn btn-outline-primary" v-on:click="showTable">
								Show Table
							</button>
							<button type="button" :disabled="loading" v-on:click="downloadXlsx" data-action="export-xlsx" class="btn btn-primary">
								Download Data
							</button>
						</div>
					</div>
				</div>

				<div class="table-responsive" :hidden="hideTable">
					<table class="table table-hover row-border" ref="tableRiwayatRekonsiliasi" id="tableRiwayatRekonsiliasi">
						<thead>
							<tr>
								<th>Tanggal Jurnal</th>
								<th>Referensi</th>
								<th>Note</th>
								<th>Nilai Hutang Usaha</th>
								<th>Total Debit</th>
								<th>Total Credit</th>
								<th>Sisa Hutang</th>
								<th>Invoice Pembayaran</th>
								<th>Bank Pembayaran</th>
							</tr>
						</thead>
						<tbody>
						</tbody>
						<tfoot>
							<tr>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
							</tr>
						</tfoot>
					</table>
				</div>
			</div>
		</div>
	</section>
	<!-- /.content -->
</template>
<script>
import { auth, authFetch, createTable, formatRupiah } from "@/libs/hxcore";
import $ from "jquery";
import moment from "moment";
import Swal from "sweetalert2";
import "vue-select/dist/vue-select.css";
import Daterangepicker from "daterangepicker";
import "daterangepicker/daterangepicker.css";

export default {
	name: "MonitoringHutangUsahaDetail",
	data() {
		return {
			rekan: {
				nama_rekan: null,
				nama_pic: null,
				telp_pic: null,
				sisa_tagihan: null
			},
			loading: true,
			filter: {
				dt1: moment().startOf('month').format("YYYY-MM-DD"),
				dt2: moment().format("YYYY-MM-DD"),
				id_rekan: this.$route.params.id,
				keyword: null,
				category: 0,
			},
			hideTable: true,
			infoDownload: false,
		};
	},
	components: {},
	created() {
		var self = this;

		authFetch("/report/hutang/cutoff")
		.then((res) => {
			if (res.status === 201) {} else if (res.status === 400) {}
			return res.json();
		})
		.then((js) => {
			if (js.success) {
				new Daterangepicker(this.$refs.daterange, {
					startDate: moment().startOf('month'),
					endDate: moment(),
					minDate: moment(js.data, 'YYYY-MM-DD').format("DD/MM/YYYY"),
					maxDate: moment().format("DD/MM/YYYY"),
					locale: {
						format: 'DD/MM/YYYY'
					},
				}, function(d1, d2) {
					self.filter.dt1 = d1.format("YYYY-MM-DD");
					self.filter.dt2 = d2.format("YYYY-MM-DD");
					if (this.dataTable) { self.dataTable.api().ajax.reload(); }
				});
			} else {
				this.customSwal.fire({
					icon: "error",
					title: "Gagal",
					text: js.message,
					confirmButtonText: "OK"
				});
			}
		});
	},
	methods: {
		formatRupiah(value) {
			return formatRupiah(value);
		},
        showTable: function () {
			if (this.dataTable) {
                this.dataTable.api().ajax.reload();
            } else {
				this.hideTable = false;
				var self = this;
				this.dataTable = createTable(this.$refs.tableRiwayatRekonsiliasi, {
					// title: "",
					roles: this.$route.params.roles,
					ajax: "/report/hutang/monitoring/" + this.$route.params.id,
					frame: false,
					toolbarEl: this.$refs.toolbar,
					fixedColumns: {
						start: 1,
						end: 1
					},
					scrollCollapse: true,
					scrollX: true,
					processing: true,
					autoWidth:false,
					language: {
						processing: '<i class="fa fa-spinner fa-5x fa-spin" style="font-size:50px;color:black;"></i>'
					},
					filterBy: [1, 2, 6, 7],
					order: [],
					paramData: function (d) {
						var filter = JSON.parse(JSON.stringify(self.filter));
						for (const key in filter) {
							d[key] = filter[key] === false ? 0 : filter[key];
						}
					},
					columns: [
						{
							data: "journal_date",
							render: function (data, type, row, meta) {
								return data ? moment(data).format("DD/MM/YYYY") : '';
							}
						},
						{ data: "no_resi" },
						{ data: "note" },
						{
							data: "hutang_usaha",
							render: function (data, type, row, meta) {
								return formatRupiah(data);
							},
							sortable: false
						},
						{
							data: "total_debit",
							render: function (data, type, row, meta) {
								return formatRupiah(data);
							},
							sortable: false
						},
						{
							data: "total_credit",
							render: function (data, type, row, meta) {
								return formatRupiah(data);
							},
							sortable: false
						},
						{
							data: "sisa_hutang",
							render: function (data, type, row, meta) {
								return formatRupiah(data);
							},
							sortable: false
						},
						{ data: "invoice_code" },
						{ data: "coa_name" }
					],
					rowCallback: function (row, data) {
						if (data.hutang_usaha < 0) {
							$("td:eq(3)", row).addClass("text-danger");
						}
						if (data.total_debit < 0) {
							$("td:eq(4)", row).addClass("text-danger");
						}
						if (data.total_credit < 0) {
							$("td:eq(5)", row).addClass("text-danger");
						}
						if (data.sisa_hutang < 0) {
							$("td:eq(6)", row).addClass("text-danger");
						}
					},
					footerCallback:function (row, data, start, end, display) {
						var api = this.api(), data;
						var totalHutang = 
							api
							.column(3, { page: 'current'})
							.data()
							.reduce( function (a, b) {
								var x = parseFloat( a ) || 0;
								var y = parseFloat( b ) || 0;
								return x + y;
							}, 0);

						var totalPembayaran = api
							.column(4, { page: 'current'})
							.data()
							.reduce( function (a, b) {
								var x = parseFloat( a ) || 0;
								var y = parseFloat( b ) || 0;
								return x + y;
							}, 0 );

						var totalSisa = api
							.column(5, { page: 'current'})
							.data()
							.reduce( function (a, b) {
								var x = parseFloat( a ) || 0;
								var y = parseFloat( b ) || 0;
								return x + y;
							}, 0 );

						// Update footer
						$( api.column(3).footer() )
							.html(formatRupiah(totalHutang))
							.toggleClass('text-danger', totalHutang < 0);
						$( api.column(4).footer() )
							.html(formatRupiah(totalPembayaran))
							.toggleClass('text-danger', totalPembayaran < 0);
						$( api.column(5).footer() )
							.html(formatRupiah(totalSisa))
							.toggleClass('text-danger', totalSisa < 0);
					},
					// initComplete: function (row, data) {
					// 	$('.loading-overlay').removeClass('show');
					// 	console.log("initComplete", row, data);
					// },
				});
			}
		},
		// downloadXlsx: function (e) {
		// 	var table = $('#tableRiwayatRekonsiliasi').DataTable();
		// 	var length = table.page.info().recordsTotal;

		// 	if (length > 20000) {
		// 		Swal.fire("Proses gagal", `Maksimal data Request sebanyak kurang lebih 20.000 data.`, "error");
		// 		return false;
		// 	}

		// 	var filter = JSON.parse(JSON.stringify(this.filter));
		// 		filter.keyword = $("input[name=q]").val();
		// 		filter.category = $("select[name=category]").val();

		// 	var data = Object.keys(filter)
		// 		.map(
		// 			(key) =>
		// 			encodeURIComponent(key) + "=" + (filter[key] === false ? 0 : encodeURIComponent(filter[key]))
		// 		)
		// 		.join("&");

		// 	this.loading = true;

		// 	authFetch("/report/hutang/monitoring_detail_excell/" + this.$route.params.id, {
		// 		method: "POST",
		// 		body: data,
		// 	})
		// 	.then((response) => {
		// 		if (response.status === 201) {
		// 		} else if (response.status === 400) {
		// 		} else if (response.status === 500){
		// 			Swal.fire("Timeout!", ``, "error");
		// 			return false;
		// 		}

		// 		return response.blob();
		// 	})
		// 	.then((blob) => {
		// 		this.loading = false;
		// 		var url = window.URL.createObjectURL(blob);
		// 		var a = document.createElement("a");
		// 		a.href = url;
		// 		a.download = "Detail Hutang Usaha.xlsx";
		// 		document.body.appendChild(a);
		// 		a.click();
		// 		a.remove();
		// 	});
		// },
		downloadXlsx: function (e) {
			this.loading = true;
			this.infoDownload = false;

			var filter = JSON.parse(JSON.stringify(this.filter));
				filter.keyword = $("input[name=q]").val() ? $("input[name=q]").val() : null;
				filter.category = $("select[name=category]").val() ? $("select[name=category]").val() : 0;

			var data = {
				"module_code": 'monitoring_hutang_usaha_detail',
				"filter": filter,
				"title": 'Detail Hutang Usaha Rekanan ' + this.rekan.nama_rekan,
				"note": JSON.stringify(filter),
			};

			const self = this;
			authFetch("/accounting/jurnal/request_download", {
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			})
			.then((res) => {
				setTimeout(() => {
					self.loading = false;
				}, 1000);
				if (res){
					self.infoDownload = true;
				}
			});
		}
	},
	mounted() {
		const e = this.$refs;
		var self = this;

		authFetch("/master/rekanan/" + this.$route.params.id)
		.then((res) => {
			if (res.status === 201) {} else if (res.status === 400) {}
			return res.json();
		})
		.then((js) => {
			this.loading = false;
			if (!js.data) {
				this.customSwal.fire({
					icon: "error",
					title: "Data tidak ditemukan",
					text: js.message,
					confirmButtonText: "Tutup",
					allowOutsideClick: false,
					customClass: {
						confirmButton: "btn btn-primary"
					}
				});
			} else if (js.success) {
				this.rekan = js.data;
				this.rekan.telp_pic = this.rekan.telp_pic ? '0' + this.rekan.telp_pic : null;
				this.rekan.sisa_tagihan = this.rekan.sisa_tagihan ? this.rekan.sisa_tagihan : 0;
			} else {
				this.customSwal.fire({
					icon: "error",
					title: "Data gagal dimuat",
					text: js.message,
					confirmButtonText: "Tutup",
					allowOutsideClick: false,
					customClass: {
						confirmButton: "btn btn-primary"
					}
				});
			}
		});

		this.customSwal = Swal.mixin({
			customClass: {
				content: 'p-0',
				title: 'h4 tex-dark',
				input: 'form-control',
				actions: 'd-flex justify-content-between flex-row-reverse',
				confirmButton: 'btn btn-primary col font-weight-bold',
				denyButton: 'btn btn-outline-primary col font-weight-bold',
				cancelButton: 'btn btn-primary w-75 font-weight-bold m-auto',
			},
			buttonsStyling: false
		});
	},
};
</script>
<style type="text/css">
.bg-bottom-primary {
	background: #FFFFFF;
	background: linear-gradient(0deg, #e96936 11.76%, #FFFFFF 11.76%);
}
</style>